enum AudienceTemplateModalVariant {
  Cnf = 'cnf',
  Blocks = 'blocks',
}

export default AudienceTemplateModalVariant;
